import {getRoomNames} from "./jobEditPopupFunctions";

export const parseJobResponse = (responseData, intl) => {
  let parsedJobData = {
    jobCartItems: [],
    jobEditPopupRoomNames: [],
    jobTotal: responseData.total,
    jobUseFabricatorCostPrices: false,
  };
  if (!Array.isArray(responseData.records) || !responseData.records.length) {
    return parsedJobData
  }
  responseData.records = responseData.records.filter(record => record && record.data);

  const lastSavedBvState = getBvStateFromResponse(responseData);
  // console.log("lastSavedBvState", lastSavedBvState);
  if (!lastSavedBvState || !lastSavedBvState.cartState || !lastSavedBvState.cartState.cartItems) {
    return parsedJobData
  }

  parsedJobData.jobCartItems = lastSavedBvState.cartState.cartItems.map(cartItem => {
    const record = responseData.records[cartItem.currentQuote];
    if (record && Array.isArray(record.features)) {
      const featureFound = record.features.find(feature => {
        return (feature.fabricatorFeatureId || feature.fabricatorFeature_id) === cartItem.cartFeature.dbFeatureId
      });
      if (featureFound) {
        cartItem.calculatedCost = featureFound.calculatedCost;
        cartItem.noteText = featureFound.noteText;
      }
    }
    return cartItem;
  });

  parsedJobData.jobEditPopupRoomNames = getRoomNames(parsedJobData.jobCartItems, intl, responseData.records);
  parsedJobData.jobUseFabricatorCostPrices = lastSavedBvState.useFabricatorCostPrices;

  return parsedJobData
}

export const getBvStateFromResponse = (responseData) => {
  if (!Array.isArray(responseData.records) || !responseData.records.length) {
    return null
  }
  responseData.records = responseData.records.filter(record => record && record.data);
  const firstRecord = responseData.records[0];
  if (!firstRecord) {
    return null
  }
  const activeQuoteIndex = firstRecord.data.activeQuoteIndex || 0;
  return responseData.records[activeQuoteIndex]
    ? responseData.records[activeQuoteIndex].data
    : null;
}
